import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../ConfigService';
import { Registro, Registrocompania } from '../../../pages/facturador/Modelos/Modelos/registro';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {

  constructor(private http: HttpClient) {

   }

  insertar(cliente:Registro): Observable<any> {
    console.log(JSON.stringify(cliente))
    const formData = new FormData();
    formData.append('cliente', JSON.stringify(cliente));
   return  this.http.post<any>(ConfigService.settings.apiUrl + 'Compania/CrearCompania',formData)
  }
  insertarEmpresariol(cliente:Registro): Observable<any> {
    console.log(JSON.stringify(cliente))
    const formData = new FormData();
    formData.append('cliente', JSON.stringify(cliente));
   return  this.http.post<any>(ConfigService.settings.apiUrlemision + 'Compania/CrearCompania',formData)
  }

}
